var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "#AEB2BE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_465)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_202_465)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91291 1.9023H3.83034V0.847656C3.83034 0.697047 3.95317 0.574219 4.10378 0.574219H4.72011C4.87071 0.574219 4.99354 0.697047 4.99354 0.847656V1.9023H9.00648V0.847656C9.00648 0.697047 9.12931 0.574219 9.27992 0.574219H9.89625C10.0469 0.574219 10.1697 0.697047 10.1697 0.847656V1.9023H12.0871C12.8244 1.9023 13.4258 2.50368 13.4258 3.241V4.09875H0.574219V3.241C0.574219 2.50368 1.17559 1.9023 1.91291 1.9023ZM13.4258 4.75502V12.0871C13.4258 12.8244 12.8244 13.4258 12.0871 13.4258H1.91291C1.17559 13.4258 0.574219 12.8244 0.574219 12.0871V4.75502H13.4258ZM2.71461 6.3551V8.01571H4.37519V6.3551H2.71461ZM2.71461 9.83697V11.4976H4.37519V9.83697H2.71461ZM9.62481 9.83697V11.4976H11.2854V9.83697H9.62481ZM6.16971 9.83697V11.4976H7.83029V9.83697H6.16971ZM9.62481 6.3551V8.01571H11.2854V6.3551H9.62481ZM6.16971 6.3551V8.01571H7.83029V6.3551H6.16971Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_202_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.ea0340f24a9799c8684f767c5092a6c0.svg";